export const REGION = 'eu-west-1';
export const USER_POOL_ID = 'eu-west-1_h6aomrgXd';
export const APP_CLIENT_ID = 'q8o68g9j3keem1u3eldd9c0f2';
export const IDENTITY_POOL_ID = 'eu-west-1:6800c948-20cf-4f56-9e3b-692456f30a5e';
export const COGNITO_DOMAIN = 'ee-portal-auth-prod.auth.eu-west-1.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'prod';
export const APPEAL_ENABLED = 'false';